<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-empty */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

import DatePicker from "vue2-datepicker";
import Switches from "vue-switches";
import Multiselect from "vue-multiselect";
import HotelDatePicker from "vue-hotel-datepicker";
import NumberInputSpinner from "vue-number-input-spinner";
import moment from "moment";
import { urlMethods } from "@/state/helpers";

export default {
  page: {
    title: "Thu hồi POS",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    HotelDatePicker,
    DatePicker,
    Switches,
    Multiselect,
    NumberInputSpinner,
  },
  data() {
    return {
      title: "Thu hồi POS",
      soName: "",
      oldSoName: "",
      products: [],
      order: false,
      reason: false,
      paymentMethod: false,
      listPaymentMethods: [],
      isDisabled: true,
      isDisabledButton: false,
      discount: 0,
      netSale: 0,
      warehouse: { id: 0, name: "" },
      note: "",
      isLoading: false,
      localError: "",
      listOrder: [],
      listReasons: [
        { id: 1, name: "Giao nhầm sản phẩm" },
        { id: 2, name: "Khách đổi hình thức thanh toán" },
        { id: 3, name: "Khách đổi mẫu" },
        { id: 4, name: "Khách hết nhu cầu" },
        { id: 5, name: "Sai chính sách" },
        { id: 6, name: "Thiếu quà tặng" },
        { id: 7, name: "Trùng đơn" },
      ],
    };
  },
  computed: {
    currentUser() {
      let user = localStorage.getItem("currentUser") || false;
      return user ? JSON.parse(user) : false;
    },
    validateForm() {
      if (this.products.length < 1) return false;
      if (this.soName.length < 5) return false;
      if (
        !this.reason ||
        typeof this.reason.id == "undefined" ||
        this.reason.id < 1
      )
        return false;
      if (
        !this.paymentMethod ||
        typeof this.paymentMethod.id == "undefined" ||
        this.paymentMethod.id < 1
      )
        return false;
      return true;
    },
    grossSale() {
      let total = 0;
      for (const item of this.products) {
        let item_total =
          parseFloat(item.price_unit) -
          (parseFloat(item.price_unit) * parseFloat(item.discount)) / 100;
        total += item_total;
      }
      total = Math.round(total);
      return total.toLocaleString();
    },

    totalAmount() {
      let total = 0;
      for (const item of this.products) {
        let item_total =
          parseFloat(item.price_unit) -
          (parseFloat(item.price_unit) * parseFloat(item.discount)) / 100;
        total += item_total;
      }
      total = Math.round(total);
      return total;
    },
  },
  methods: {
    ...urlMethods,
    setLocalError(text) {
      this.localError = text;
    },
    formatMoney(input) {
      if (
        typeof input == "undefined" ||
        input == null ||
        !input ||
        isNaN(input)
      )
        return 0;
      return input.toLocaleString();
    },
    async getWarehouse() {
      let that = this;
      try {
        let res = await that.getUrl("warehouse");
        that.warehouse = res.data;
      } catch (error) {}
    },
    async getPaymentMethods() {
      let that = this;
      try {
        let res = await that.getUrl("hbpos/payment-methods");
        that.listPaymentMethods = res.data || [];
        const cash = that.listPaymentMethods.find(m => m.name && m.name.toLowerCase().includes("tiền mặt"));
        if (cash) that.paymentMethod = cash;
      } catch (error) {}
    },
    removeItem(product_id, lot_name) {
      lot_name = lot_name == null ? "" : lot_name;
      product_id = product_id == null ? "" : product_id;
      this.products = this.products.filter(function(item) {
        if (lot_name == "") {
          return item.product_id != product_id ? item : false;
        }
        return item.lot_name != lot_name ? item : false;
      });

      console.log(this.products);
    },
    price_total(item) {
      return Math.round(
        item.price_unit - (item.price_unit * item.discount) / 100,
        0
      );
    },
    async saveOrder() {
      let that = this;
      if (this.soName.length < 5) {
        that.setLocalError("Chưa có thông tin đơn hàng thu hồi");
        return false;
      }
      if (this.products.length < 1) {
        that.setLocalError("Chưa có thông tin sản phẩm thu hồi");
        return false;
      }
      if (!this.reason || typeof this.reason.id == "undefined" || this.reason.id < 1) {
        that.setLocalError("Chưa chọn lý do thu hồi");
        return false;
      }
      if (!this.paymentMethod || typeof this.paymentMethod.id == "undefined" || this.paymentMethod.id < 1) {
        that.setLocalError("Chưa chọn phương thức thanh toán");
        return false;
      }
      if (!that.validateForm) {
        that.setLocalError("Vui lòng điền đầy đủ thông tin trước khi tạo đơn");
        return false;
      }
      if (this.grossSale < 0) {
        that.setLocalError("Bạn không thể thu hồi đơn hàng số tiền < 0₫");
        return false;
      }
      that.localError = "";
      let body = {
        order_id: that.order.id,
        partner_id: that.order.partner_id,
        revoke_id: that.reason.id,
        lines: that.products,
        saler: that.order.saler,
        saler_id: that.order.saler_id,
        location_id: that.warehouse.id,
        payment_method_id: that.paymentMethod.id,
        note: that.note,
        totalAmount: that.totalAmount,
      };
      that.isLoading = true;
      that.isDisabledButton = true;
      setTimeout(async () => {
        try {
          let res = await that.postUrl({ url: "hbpos/add", data: body });
          if (typeof res.error != "undefined" && res.error) throw res.message;
          that.$router.push(`/hbpos/${res.data}`);
          that.isLoading = false;
        } catch (error) {
          that.isLoading = false;
          that.isDisabledButton = false;
          let text = typeof error == "string" ? error : JSON.stringify(error);
          that.setLocalError(text);
        }
      }, 100);
    },
    async setOrder(item) {
      let that = this;
      that.isLoading = true;
      that.oldSoName = item.name;
      that.soName = item.name;
      setTimeout(async () => {
        try {
          let res = await that.postUrl({
            url: "hbpos/lines-order",
            data: { id: item.id },
          });
          that.isLoading = false;
          this.$bvModal.hide("modal-search-order");
          if (
            typeof res.data == "undefined" ||
            typeof res.data[0] == "undefined"
          ) {
            throw "Đơn hàng không khả dụng để thu hồi. Vui lòng kiểm tra lại";
          }
          that.order = res.data[0];
          that.products = res.data;
        } catch (error) {
          that.isLoading = false;
          this.$bvModal.hide("modal-search-order");
          let text = typeof error == "string" ? error : JSON.stringify(error);
          that.$store.dispatch("sale/setNoti", { text: text, type: "error" });
        }
      }, 50);
    },
    async searchOrder() {
      let that = this;
      that.soName = that.soName.replace(/ /g, "");
      if (that.soName.length < 5) {
        return false;
      }
      if (that.oldSoName == that.soName && that.products.length > 0)
        return false;
      that.oldSoName = that.soName;
      that.products = [];
      that.order = false;
      that.listOrder = [];
      that.isLoading = true;
      setTimeout(async () => {
        try {
          let res = await that.postUrl({
            url: "hbpos/search-order",
            data: { name: that.soName },
          });
          that.isLoading = false;
          if (
            typeof res.data == "undefined" ||
            typeof res.data[0] == "undefined"
          ) {
            throw "Không tìm thấy thông tin đơn hàng. Vui lòng kiểm tra lại";
          }
          if (res.data.length == 1) {
            that.setOrder(res.data[0]);
          } else {
            that.listOrder = res.data;
            this.$bvModal.show("modal-search-order");
          }
        } catch (error) {
          that.isLoading = false;
          let text = typeof error == "string" ? error : JSON.stringify(error);
          that.$store.dispatch("sale/setNoti", { text: text, type: "error" });
        }
      }, 50);
    },
  },
  mounted() {
    this.getWarehouse();
    this.getPaymentMethods();
  },
};
</script>

<template>
  <Layout>
    <div class="page-header mb-3">
      <div class="page-title">
        <h4 class="mb-0 font-size-18">THU HỒI ĐƠN POS</h4>
      </div>
    </div>
    <div class="card">
      <div class="card-body p-2">
        <div class="row mb-2">
          <div class="col-md-6  mb-0">
            <div class="card p-0  mb-0">
              <div class="card-body p-0  mb-0" style="background: white;">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th width="140px" valign="middle">Mã đơn hàng</th>
                      <td scope="row" class="has-input">
                        <div class="flex-box">
                          <div class="flex-full mr-2">
                            <b-form-input
                              @keyup.enter="searchOrder"
                              ref="soName"
                              autocomplete="off"
                              for="soName"
                              v-model="soName"
                            ></b-form-input>
                          </div>
                          <button
                            type="button"
                            class="btn btn-primary btn-search"
                            @click="searchOrder"
                          >
                            <i class="bx bx-search-alt search-icon"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th valign="middle">Khách hàng</th>
                      <td scope="row">
                        {{
                          typeof order.customer_name != "undefined"
                            ? order.customer_name + " - " + order.customer_phone
                            : ""
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th valign="middle">Kho nhận</th>
                      <td scope="row">
                        {{
                          typeof warehouse.name != "undefined"
                            ? warehouse.name
                            : ""
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th valign="middle">NVBH</th>
                      <td scope="row">
                        {{
                          typeof order.saler != "undefined" ? order.saler : ""
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-md-6  mb-0">
            <div class="card p-0  mb-0">
              <div class="card-body p-0 mb-0" style="background: white;">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th width="140px" valign="middle">Ngày bán hàng</th>
                      <td scope="row">
                        {{
                          typeof order.create_date != "undefined"
                            ? order.create_date
                            : ""
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th valign="middle">Lý do thu hồi</th>
                      <td scope="row" class="has-input">
                        <multiselect
                          track-by="id"
                          label="name"
                          v-model="reason"
                          :options="listReasons"
                          placeholder="--- Chọn lý do thu hồi ---"
                          :allow-empty="false"
                        ></multiselect>
                      </td>
                    </tr>
                    <tr>
                      <th valign="middle">Thanh toán</th>
                      <td scope="row" class="has-input">
                        <multiselect
                          track-by="id"
                          label="name"
                          v-model="paymentMethod"
                          :options="listPaymentMethods"
                          placeholder="--- Chọn phương thức thanh toán ---"
                          :allow-empty="false"
                        ></multiselect>
                      </td>
                    </tr>
                    <tr>
                      <th valign="middle">Ghi chú</th>
                      <td scope="row" class="has-input">
                        <b-form-input
                          autocomplete="off"
                          v-model="note"
                        ></b-form-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-tabs
        content-class="p-2"
        nav-wrapper-class="nav-item"
        class="p-0"
        nav-class="nav-tabs-custom"
        v-if="products.length > 0"
      >
        <b-tab title="Sản phẩm" active>
          <div class="table-responsive" style="padding: 0px">
            <table class="table table-striped table-bordered mb-0">
              <thead>
                <tr>
                  <th>Serial</th>
                  <th>Sản phẩm</th>
                  <!-- <th>Số lượng</th> -->
                  <th>Đơn giá</th>
                  <th>Giảm giá (%)</th>
                  <th>Tổng tiền</th>
                  <th><i class="fa fa-cogs"></i></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in products" :key="index">
                  <td>{{ item.lot_name ? item.lot_name : "_" }}</td>
                  <td>{{ item.product_name }}</td>
                  <!-- <td class="has-input">{{ item.quantity }}</td> -->
                  <td class="has-input">
                    <money
                      class="form-control text-right"
                      autocomplete="off"
                      v-model="item.price_unit"
                    ></money>
                  </td>
                  <td class="has-input">
                    <money
                      class="form-control text-right"
                      autocomplete="off"
                      v-model="item.discount"
                    ></money>
                  </td>
                  <td class="text-right">
                    {{ formatMoney(price_total(item)) }}
                  </td>
                  <td class="has-input">
                    <button
                      @click="removeItem(item.product_id, item.lot_name)"
                      class="btn btn-danger btn-sm"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="text-right pt-3 font-size-18">
            <b>THÀNH TIỀN: {{ grossSale }} <sup>₫</sup></b>
          </div>
        </b-tab>
      </b-tabs>
      <div class="p-3 d-flex align-items-center" v-if="products.length > 0">
        <div v-if="localError" style="background:#dc3545;color:#fff;padding:8px 14px;border-radius:4px;font-weight:500;margin-right:12px;">
          <strong>LỖI!</strong> {{ localError }}
        </div>
        <button
          @click="saveOrder"
          type="button"
          class="btn btn-primary flex-shrink-0 ms-auto"
          :disabled="isDisabledButton"
        >
          Tạo đơn
        </button>
      </div>
    </div>

    <b-modal
      id="modal-search-order"
      title="Chọn đơn bán hàng"
      size="lg"
      title-class="font-18"
      hide-footer
    >
      <div class="table-responsive" style="padding: 0px">
        <table class="table table-striped table-bordered mb-0">
          <thead>
            <tr>
              <th>Mã đơn</th>
              <th>Ngày bán</th>
              <th>Khách hàng</th>
              <th>Tổng tiền</th>
              <th><i class="fa fa-cogs"></i></th>
            </tr>
          </thead>
          <tbody>
            <tr
              style="cursor:pointer"
              v-for="(item, index) in listOrder"
              :key="index"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.create_date }}</td>
              <td>{{ item.customer_name }}</td>
              <td>{{ parseFloat(item.amount_total).toLocaleString() }}</td>
              <td>
                <button
                  @click="setOrder(item)"
                  type="button"
                  class="btn btn-sm btn-primary"
                >
                  Thu hồi
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <div :class="isLoading ? 'flex-middle-full loading-full' : 'hidden'">
      <i class="fas fa-spinner fa-spin font-size-34"></i>
    </div>
  </Layout>
</template>
